import React from 'react';
import Main from '../../Components/Policy/Main/Main';

export default (): React.ReactElement => (
  <Main />
);
